import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './RelatedAddressEditor.html?raw';

import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import _uiFrameMixin from '../../../../moreCore/UI/Container/uiFrame';
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import lang from 'dojo/_base/lang';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { RelatedAddress } from "../RelatedAddressTypes";

class RelatedAddressEditor extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin, _uiFrameMixin) {
    templateString: any = template;

    private isNew: boolean;

    private inputRelationType: MdsLax<InstanceType<typeof HintBox>>;
    private inputRelatedAddress: MdsLax<InstanceType<typeof HintBox>>;


    protected afterSetData(): void {
        var relationTypeEntity = this.getAttributeValue("ref_relation_type");
        var relationTypePlaintext = this.getAttributeValue("c_relation_type");

        if (!relationTypeEntity) this.inputRelationType.setValue(relationTypePlaintext, true);
    }

    private _onClickSEDButton(mode: string, e: MouseEvent) {
        this.openSelectEntityDialog(e, mode, lang.hitch(this, this._onSEDResponse))
    }

    openEditor(relatedAddress: RelatedAddress, isNew: boolean): void {
        this.isNew = isNew;
        this.setData(relatedAddress);
        var title = relatedAddress?.gDisp_1 ? relatedAddress.gDisp_1 : this.translate("General_New") + " - " + this.translate("General_Label_RelatedAddress");


        this.show("dlg", title);
        this.createDefaultButton("ok", lang.hitch(this, this._onClickConfirm));
    }

    private _onClickConfirm() {
        var relationTypeEntity = this.inputRelationType.getValue("entity");
        var relationTypePlaintext = this.inputRelationType.getValue("plaintext");

        this.setAttributeValue("ref_relation_type", relationTypeEntity);
        this.setAttributeValue("c_relation_type", relationTypePlaintext);

        this.emit("confirmed", { entity: this.getCurrentData(), isNew: this.isNew });
        this.close();
    }

    private _onSEDResponse(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<RelatedAddress>>) {
        if (items && items.length > 0) {
            var entity = items[0].entry.data;
            switch (mode) {
                case "relatedAddress":
                    this.inputRelatedAddress.setValue(entity);
                    break;
                case "relationType":
                    this.inputRelationType.setValue(entity);
                    break;
            }
        }
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API_AddressWizard__RelatedAddresses_GetSEDConfig";

        this.inputRelatedAddress.addInlineButton(lang.hitch(this, this._onClickSEDButton, "relatedAddress"));
        this.inputRelationType.addInlineButton(lang.hitch(this, this._onClickSEDButton, "relationType"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(RelatedAddressEditor);